import { render } from "./pie_chart_5.svg?vue&type=template&id=0059dc84"
const script = {}
script.render = render

export default script